var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3583_11090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70387 11.8085C9.31254 11.8085 11.4273 9.69377 11.4273 7.0851C11.4273 4.47644 9.31254 2.3617 6.70387 2.3617C4.09521 2.3617 1.98047 4.47644 1.98047 7.0851C1.98047 9.69377 4.09521 11.8085 6.70387 11.8085Z",
    stroke: "white",
    strokeWidth: 0.899696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7041 4.98581H6.71206",
    stroke: "white",
    strokeWidth: 0.899696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17969 7.08511H6.70451V9.1844H7.22933",
    stroke: "white",
    strokeWidth: 0.899696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3583_11090"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.40625 0.787231H13.002V8.80352C13.002 11.3327 10.9517 13.383 8.42254 13.383H4.98571C2.45654 13.383 0.40625 11.3327 0.40625 8.80352V0.787231Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhiteIcon);
export default __webpack_public_path__ + "static/media/info-white-icon.a491e063f23face920a5cb345c6942b9.svg";
export { ForwardRef as ReactComponent };